import { SearchIcon } from '@chakra-ui/icons';
import {
	IconButton,
	Input,
	InputGroup,
	InputLeftElement,
	useColorModeValue,
} from '@chakra-ui/react';
export function SearchBar(props) {
	const { variant, children, borderRadius, setSearch, ...rest } = props;

	const searchIconColor = useColorModeValue('gray.900', 'gray.100');
	const searchColor = useColorModeValue('gray.900', 'gray.100');
	const inputBg = useColorModeValue('transparent', 'gray.900');

	return (
		<InputGroup
			{...rest}
			zIndex='0'
			bg={inputBg}
			border='1px solid'
			color={searchColor}
			borderColor={useColorModeValue('secondaryGray.100', 'gray.100Alpha.100')}
			borderRadius='16px'
			_placeholder={{ color: 'gray.900' }}
			me={{ base: '10px', md: '20px' }}
		>
			<InputLeftElement
				children={
					<IconButton
						bg='inherit'
						borderRadius='inherit'
						_hover='none'
						_active={{
							bg: 'inherit',
							transform: 'none',
							borderColor: 'transparent',
						}}
						_focus={{
							boxShadow: 'none',
						}}
						icon={<SearchIcon color={searchIconColor} w='15px' h='15px' />}
					></IconButton>
				}
			/>
			<Input
				w={{
					base: '100px',
					md: '270px',
					lg: '530px',
					xl: '660px',
					'2xl': '860px',
					'3xl': '860px',
				}}
				maxW='100%'
				variant='search'
				fontSize='sm'
				bg={inputBg}
				color={searchColor}
				fontWeight='500'
				borderRadius={borderRadius ? borderRadius : '30px'}
				placeholder='Busca aquí...'
				onChange={(e) => setSearch(e.target.value)}
			/>
		</InputGroup>
	);
}
